<template>
    <v-container fluid>
      <v-card>
        <div style="position: relative">
          <div
              ref="logMessages"
              style="padding: 16px;height: calc(100vh - 16px - 44px - 16px);overflow-y: auto"
              @scroll="onScroll">
            <div :key="`${item.id}`" v-for="item in filteredLogs">
              {{ item.message }}
            </div>
          </div>
          <v-btn
              icon="mdi-chevron-down"
              style="position: absolute;right: 32px;bottom: 16px;"
              v-if="!stickyBottom"
              @click="onScrollToBottom"
          ></v-btn>
        </div>
        <div class="d-flex justify-start align-center">
          <v-text-field
              v-model="searchText"
              variant="solo" density="compact" hide-details placeholder="검색어를 입력하세요."
              prepend-inner-icon="mdi-magnify"
              clearable
          ></v-text-field>
        </div>
      </v-card>
  </v-container>
</template>

<script setup>

import {computed, inject, nextTick, onMounted, onUnmounted, ref, watch} from 'vue';
import {useRouter} from "vue-router";
import {useAppStore} from "@/stores/app";
import {useSessionStore} from "@/stores/session";
import dayjs from "dayjs";

const LOGS_UPDATE_INTERVAL = 10_000;

const axios = inject('axios');
const network = inject('network');
const router = useRouter();
const appStore = useAppStore();
const sessionStore = useSessionStore();

const responseChain = {
  sessionExpired: async (response, next) => {
    if (response && response.data && 1000 === response.data.code) {
      sessionStore.authorized = false;
      await router.push({name: 'Login'});
      return;
    }
    next && next();
  }
};

const logMessages = ref(null);
const loadDeviceInterval = ref(0);
const toggle = ref(null);
const stickyBottom = ref(true);
const searchText = ref('');

const filteredLogs = computed(() => appStore.logs
    .map(log => ({...log, message: `${dayjs(log.createdAt).format('YYYY-MM-DD HH:mm:ss.SSS')} ${log.message}`}))
    .filter(log =>
        !searchText.value || !searchText.value.trim() ||
        log.message.toUpperCase().includes(searchText.value.trim().toUpperCase())
    )
);

onMounted(() => {
  const intervalResponseChain = network.useResponseChain()
      .use(responseChain.sessionExpired);
  appStore.loadLogs()
  appStore.loadLogs().then(response => {
    intervalResponseChain.run(response);
    loadDeviceInterval.value = setInterval(() =>
            appStore.loadLogs().then(response => intervalResponseChain.run(response)),
        LOGS_UPDATE_INTERVAL);
  });
});

onUnmounted(() => {
  loadDeviceInterval.value && clearInterval(loadDeviceInterval.value);
  loadDeviceInterval.value = 0;
});

watch(filteredLogs, () => {
  if (!stickyBottom.value) return;

  nextTick(() => {
    if (!logMessages.value) return;
    logMessages.value.scrollTop = logMessages.value.scrollHeight;
  });
}, {
  immediate: true,
});

const onScroll = () => {
  if (!logMessages.value) return;

  stickyBottom.value = logMessages.value.scrollHeight - logMessages.value.scrollTop === logMessages.value.clientHeight;
};

const onScrollToBottom = () => {
  if (!logMessages.value) return;

  logMessages.value.scrollTop = logMessages.value.scrollHeight - logMessages.value.clientHeight;
  stickyBottom.value = true;
};

</script>

<style scoped>

</style>
